import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";
import { getFieldOptions } from "../common/selectors";
import { notBlank } from "../common/general";
import { mergeRight, propOr } from "ramda";
import IntlTextField from "./IntlTextField";

const AutocompleteInputField = (props) => {
  const {
    fieldOption,
    name,
    defaultLabel,
    value,
    onChange,
    error,
    helperText,
    onBlur,
    xs,
    sm,
    inputProps,
    params = {},
  } = props;

  //-- Maybe pull this into a useEffect
  if (notBlank(inputProps)) {
    params.inputProps = mergeRight(propOr("inputProps", params), inputProps);
  }

  const fieldOptions = useSelector(getFieldOptions);
  const [showField, setShowField] = useState(true);
  const [label, setLabel] = useState("");
  useEffect(() => {
    if (notBlank(fieldOptions[fieldOption])) {
      const option = fieldOptions[fieldOption];
      setShowField(!option.hidden);

      if (notBlank(option.fieldLabel)) {
        setLabel(option.fieldLabel);
      } else if (notBlank(defaultLabel)) {
        setLabel(defaultLabel);
      } else {
        setLabel("No Label Defined");
      }
    } else {
      setShowField(true);

      if (notBlank(defaultLabel)) {
        setLabel(defaultLabel);
      } else {
        setLabel("No Label Defined");
      }
    }
  }, [fieldOptions, fieldOption, defaultLabel, value]);

  const wrapGrid = (element) => {
    if (notBlank(xs) || notBlank(sm)) {
      return (
        <Grid item xs={xs || 12} sm={sm || 6}>
          {element}
        </Grid>
      );
    } else {
      return element;
    }
  };

  return (
    showField &&
    wrapGrid(
      <IntlTextField
        {...params}
        fullWidth
        type="text"
        variant="standard"
        label={label}
        onChange={onChange}
        error={error}
        helperText={helperText}
        onBlur={onBlur}
        name={name}
      />
    )
  );
};

export default AutocompleteInputField;
